export const Sidebar = () => {
  const container = document.querySelector(".page");
  const sidebarContainer = document.querySelector(".sidebar");
  const sidebarOpener = document.querySelector(".sidebar-opener");
  const sidebarBackdrop = document.querySelector(".sidebar-backdrop");

  if (!container || !sidebarContainer || !sidebarOpener) return;

  sidebarOpener.addEventListener("click", () => {
    container.classList.toggle("sidebar-opened");
  });
};
